import { ComboboxButton } from '@headlessui/react';

import Props from '@/components/@base/input/combobox/button/type';

const Button = ({ children, ...props }: Props) => {
  return <ComboboxButton {...props}>{children}</ComboboxButton>;
};

export default Button;
